/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductList } from './ProductList';
// @ts-ignore
import {
// @ts-ignore
    ProductListFromJSON,
// @ts-ignore
    ProductListFromJSONTyped,
// @ts-ignore
    ProductListToJSON,
} from './ProductList';

/**
 * 
 * @export
 * @interface ProductListListResponse
 */
export interface ProductListListResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductListListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<ProductList>}
     * @memberof ProductListListResponse
     */
    items: Array<ProductList>;
}

/**
 * Check if a given object implements the ProductListListResponse interface.
 */
// @ts-ignore
export function instanceOfProductListListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListListResponseFromJSON(json: any): ProductListListResponse {
    return ProductListListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(ProductListFromJSON)),
    };
}

// @ts-ignore
export function ProductListListResponseToJSON(value?: ProductListListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(ProductListToJSON)),
    };
}

